export default () => ({
  editableCell: {
    padding: '0 8px'
  },
  right: {},
  switchCell: {
    display: 'flex',
    padding: '15px 0 10px 0',
    alignItems: 'center'
  }
});